import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about6">

      {/* ================= HERO ================= */}
      <section className="ab-hero">
        <div className="ab-hero-inner">
          <h1>Built With Purpose</h1>
          <p>
            This is not a gym built on hype.
            It’s a space engineered for discipline, clarity, and long-term strength.
          </p>
        </div>
      </section>

      {/* ================= PHILOSOPHY ================= */}
      <section className="ab-philosophy">
        <div className="ph-left">
          <h2>Our Philosophy</h2>
        </div>

        <div className="ph-right">
          <p>
            We believe performance should feel intentional.
            Every movement has structure. Every session has direction.
          </p>
          <p>
            No chaos. No distraction.
            Just focused training that compounds over time.
          </p>
        </div>
      </section>

      {/* ================= VALUES GRID ================= */}
      <section className="ab-values">
        <div className="val-card">
          <h3>Discipline</h3>
          <p>Progress is built through consistency, not motivation.</p>
        </div>

        <div className="val-card">
          <h3>Structure</h3>
          <p>Clear programs create measurable outcomes.</p>
        </div>

        <div className="val-card">
          <h3>Longevity</h3>
          <p>Training designed for years, not seasons.</p>
        </div>
      </section>

      {/* ================= IMAGE + TEXT ================= */}
      <section className="ab-split">
        <div className="ab-img">
          <img
            src="https://images.pexels.com/photos/949126/pexels-photo-949126.jpeg"
            alt="training space"
          />
        </div>

        <div className="ab-text">
          <h2>Designed For Focus</h2>
          <p>
            Every detail — lighting, spacing, programming —
            is engineered to remove noise and sharpen execution.
          </p>
          <p>
            This is a place where training becomes ritual.
          </p>
        </div>
      </section>

      {/* ================= STATEMENT ================= */}
      <section className="ab-statement">
        <h1>
          Strength Is Not Loud.<br />
          It Is Built Quietly.
        </h1>
      </section>

    </div>
  );
};

export default About;
